export default __webpack_public_path__ + "static/media/icomoon.7edd1310.ttf";